<template>
  <i role="img" :aria-label="ariaLabel" :class="iconClassList" @click="onClick">
    <slot></slot>
  </i>
</template>

<script lang="ts">
  import sizeable from '../../mixins/sizeable/sizeable';
  import colorable from '../../mixins/colorable/colorable';
  import mixins from '../../mixins';
  import _ from '../../utils';

  export default mixins(colorable, sizeable).extend({
    mixins: [sizeable, colorable],
    props: {
      color: { default: undefined, type: String },
      right: { default: false, type: Boolean },
      left: { default: false, type: Boolean },
      disabled: { default: false, type: Boolean },
    },
    data: () => ({
      chosenIcon: undefined as string | undefined,
    }),
    computed: {
      ariaLabel(): string | undefined {
        return this.chosenIcon?.replace(/_/g, ' ');
      },
      iconClassList(): Record<string, boolean> {
        return {
          'p-icon': true,
          'material-icons': true,
          interactable: !this.disabled && (this.$listeners as any).click !== undefined,
          [`text-color-${this.color}`]: !this.disabled && this.color !== undefined,
          'text-color-disabled': this.disabled,
          dense: this.dense,
          spacious: this.spacious,
          left: this.left,
          right: this.right,
        };
      },
    },
    updated() {
      const defaultSlot = _.component.getSlot(this, 'default');
      this.chosenIcon = defaultSlot?.text?.trim();
    },
    methods: {
      onClick(event: any) {
        this.$emit('click', event);
      },
    },
  });
</script>
